module.exports = __webpack_public_path__ + "static/media/dados-pessoais.9003fc33.svg";